import type { PmNodeConverter, PmNodeJson } from './../../pm-converters/types';
import { generateId } from './../../ricos-content';
import { TIPTAP_FIGURE_TYPE, TIPTAP_VIDEO_TYPE } from './../../ricos-content/consts';
import type { Node } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { VideoNode } from './../../ricos-types';

export const videoConverter: PmNodeConverter = {
  toPm: {
    types: [Node_Type.VIDEO],
    // @ts-ignore $TSFixMe
    convert: (node: VideoNode, visit: (node: Node) => PmNodeJson[]) => {
      const fallbackCaption: Node = {
        id: generateId(),
        type: Node_Type.CAPTION,
        nodes: [],
      };

      return {
        type: TIPTAP_FIGURE_TYPE,
        attrs: {
          id: generateId(),
        },
        content: [
          {
            type: TIPTAP_VIDEO_TYPE,
            attrs: {
              ...node.videoData,
              id: node.id,
            },
          },
          ...visit(node.nodes?.length > 0 ? node : { ...node, nodes: [fallbackCaption] }),
        ],
      };
    },
  },
  fromPm: {
    types: [TIPTAP_FIGURE_TYPE, TIPTAP_VIDEO_TYPE],
    convert: (node, visit) => {
      if (node.type === TIPTAP_VIDEO_TYPE) {
        return undefined;
      }
      const videoNode = node.content?.find(({ type }) => type === TIPTAP_VIDEO_TYPE);

      if (!videoNode) {
        return undefined;
      }

      const { id, ...data } = videoNode?.attrs || {};

      const [captionNode] = visit?.(node) ?? [];

      const { spoiler, ...rest } = data.containerData || {};
      const containerData = {
        ...rest,
        ...(spoiler?.enabled ? { spoiler: { ...spoiler } } : {}),
      };

      return {
        type: Node_Type.VIDEO,
        id: id ?? generateId(),
        nodes: captionNode?.nodes[0]?.textData?.text ? [captionNode] : [],
        videoData: {
          ...data,
          disableDownload: data.disableDownload || undefined,
          containerData: Object.keys(containerData).length ? containerData : undefined,
        },
      };
    },
  },
};
